import { getDeviceInfo } from '@modules/standard';
import { useEffect, useState } from 'react';

export enum ScreenType {
  // 모바일 (전체화면)
  Mobile = 'mobile',
  // 앱 페이지 내부 컴포넌트에서 그려지는 뷰(모바일/데스크탑 모두 적용)
  InComponent = 'inComponent',
  // 데스크탑 (전체화면)
  Desktop = 'desktop',
}

export interface ScreenInfo {
  screenType: ScreenType;
  isDesktop: boolean;
  isMobile: boolean;
  isInComponent: boolean;
  windowWidth: number;
  windowHeight: number;
}

const getScreenType = (): ScreenType => {
  if (typeof window === 'undefined') {
    return ScreenType.Desktop; // 기본값 반환
  }
  
  const params = new URLSearchParams(window.location.search);
  const domain = params.get('domain');
  
  // TODO: 현재 컴포넌트 높이 기준으로 InComponent 판별. 좀더 명확한 기준 필요. 
  if (domain === 'zigbang' && window.innerHeight <= 340) {
    return ScreenType.InComponent;
  }

  if (domain === 'hogangnono' && window.innerHeight <= 380) {
    return ScreenType.InComponent;
  }

  if (getDeviceInfo().isMobileOrTablet) {
    return ScreenType.Mobile;
  }

  return ScreenType.Desktop;
};

export const useScreen = (): ScreenInfo => {
  const [screenInfo, setScreenInfo] = useState<ScreenInfo>(() => {
    if (typeof window === 'undefined') {
      return {
        screenType: ScreenType.Desktop,
        isDesktop: true,
        isMobile: false,
        isInComponent: false,
        windowWidth: 1024,
        windowHeight: 768,
      };
    }

    const screenType = getScreenType();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    return {
      screenType,
      isDesktop: screenType === ScreenType.Desktop,
      isMobile: screenType === ScreenType.Mobile,
      isInComponent: screenType === ScreenType.InComponent,
      windowWidth,
      windowHeight,
    };
  });

  useEffect(() => {
    const updateScreenInfo = () => {
      const screenType = getScreenType();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      setScreenInfo({
        screenType,
        isDesktop: screenType === ScreenType.Desktop,
        isMobile: screenType === ScreenType.Mobile,
        isInComponent: screenType === ScreenType.InComponent,
        windowWidth,
        windowHeight,
      });
    };

    // 초기 설정
    updateScreenInfo();

    // 리사이즈 이벤트 리스너 등록
    window.addEventListener('resize', updateScreenInfo);
    
    // URL 변경 감지 (domain 파라미터 변경 시)
    window.addEventListener('popstate', updateScreenInfo);

    return () => {
      window.removeEventListener('resize', updateScreenInfo);
      window.removeEventListener('popstate', updateScreenInfo);
    };
  }, []);

  return screenInfo;
};
